import { useVeltClient, VeltCommentTool, VeltSidebarButton } from '@veltdev/react';
import React, { useEffect } from 'react'

function Header() {

    const { client } = useVeltClient();

    useEffect(() => {
        if (client) {
            identify();
            setDocumentId('chart-js-demo');
        }
    }, [client]);

    const identify = async () => {
        try {
            const user = {
                userId: '1',
                name: 'John Smith',
                photoUrl: '',
                email: 'john@trysnippyly.com',
                plan: 'free',
            };
            await client.identify(user);
        } catch (error) {
            console.error(error);
        }
    }

    const setDocumentId = (documentId: string) => {
        try {
            client?.setDocumentId(documentId);
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <div className='page-header'>
            <div className='page-header-title'>
                Chart JS Demo
            </div>
            <div className='page-header-actions'>
                <VeltCommentTool />
                <VeltSidebarButton />
            </div>
        </div>
    )
}

export default Header;